"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _reactResponsive = require("react-responsive");
var _ui = require("../../ui");
var _Icon = require("../Icon");
var _Name = require("../Name");
var _NumberFormat = require("../NumberFormat");
var _utils = require("../../../utils");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var allTickers = function allTickers(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "23.0756",
    cy: "12",
    r: "12",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.0741 4L22.9692 4.36459V14.9441L23.0741 15.0512L27.8726 12.1484L23.0741 4Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.0741 4L18.2755 12.1484L23.0741 15.0513V9.91626V4Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.0741 15.9811L23.015 16.0548V19.8234L23.0741 20L27.8755 13.0797L23.0741 15.9811Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.0741 19.9999V15.981L18.2755 13.0796L23.0741 19.9999Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12.0756",
    cy: "12",
    r: "12",
    fill: "#FF8401"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.0993 11.4652C15.8098 11.073 16.2543 10.3822 16.1504 9.23149C16.0106 7.65887 14.7576 7.13153 13.1759 6.98135L13.1755 4.8H11.95L11.9497 6.92399C11.6272 6.92399 11.2985 6.93085 10.9713 6.93797L10.971 4.80029L9.74658 4.80017L9.74636 6.98098C9.48099 6.98686 9.22039 6.99244 8.96593 6.99244V6.98599L7.27551 6.98524L7.27574 8.40314C7.27574 8.40314 8.18078 8.38469 8.16587 8.4026C8.66209 8.40297 8.82412 8.71524 8.87072 8.98478L8.8711 11.4698V14.9604C8.84925 15.1296 8.75731 15.3999 8.41034 15.4004C8.42613 15.4154 7.51884 15.4002 7.51884 15.4002L7.27574 16.9857H8.87033C9.16746 16.9861 9.45941 16.9911 9.74582 16.9936L9.74689 19.1996L10.971 19.2L10.9707 17.0171C11.3075 17.0245 11.6325 17.0278 11.9501 17.0273L11.9497 19.2H13.1752L13.1759 16.9976C15.2359 16.8694 16.6781 16.3071 16.8574 14.2106C17.0019 12.5228 16.2689 11.7694 15.0993 11.4652ZM11.0006 8.49884C11.6918 8.49884 13.8656 8.26032 13.8659 9.825C13.8656 11.3251 11.6925 11.1498 11.0006 11.1498V8.49884ZM11 15.4111L11.0006 12.4882C11.831 12.4879 14.4358 12.2292 14.4361 13.949C14.4364 15.5982 11.831 15.4105 11 15.4111Z",
    fill: "white"
  }));
};
allTickers.defaultProps = {
  width: "36",
  height: "24",
  viewBox: "0 0 36 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-right: 6px;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});
var TickerIcon = (0, _styledComponents.default)(_Icon.Icon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n"])));
var TertiarySmall = (0, _styledComponents.default)(_ui.Small)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-left: 4px;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.tertiaryShade;
});
var Label = function Label(_ref3) {
  var ticker = _ref3.ticker,
    balance = _ref3.balance,
    checked = _ref3.checked,
    showChecked = _ref3.showChecked,
    optionsSelected = _ref3.optionsSelected;
  var _useTranslation = (0, _reactI18next.useTranslation)('libCommon'),
    t = _useTranslation.t;
  var isTable = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.lg
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center justify-content-between"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center"
  }, ticker !== 'ALL' && showChecked && /*#__PURE__*/_react.default.createElement(_ui.CheckBoxInput, {
    checked: checked
  }), /*#__PURE__*/_react.default.createElement(IconWrapper, null, ticker === 'ALL' || optionsSelected ? /*#__PURE__*/_react.default.createElement(_ui.Svg, {
    as: allTickers
  }) : /*#__PURE__*/_react.default.createElement(TickerIcon, {
    ticker: ticker
  })), optionsSelected ? /*#__PURE__*/_react.default.createElement(_ui.P, null, optionsSelected, " ", t('selected')) : ticker === 'ALL' ? /*#__PURE__*/_react.default.createElement(_ui.P, null, t('allCurrencies')) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ui.P, null, /*#__PURE__*/_react.default.createElement(_Name.Name, {
    ticker: ticker
  })), !isTable && /*#__PURE__*/_react.default.createElement(TertiarySmall, null, /*#__PURE__*/_react.default.createElement(_Name.Name, {
    full: true,
    ticker: ticker
  })))), balance && /*#__PURE__*/_react.default.createElement(TertiarySmall, null, /*#__PURE__*/_react.default.createElement(_NumberFormat.NumberFormat, {
    value: balance.value,
    ticker: balance.ticker
  })));
};
exports.Label = Label;